// extracted by mini-css-extract-plugin
export var body = "component-module--body--ef0a9";
export var bordered = "component-module--bordered--eda29";
export var curvedBottomBorder = "component-module--curvedBottomBorder--3327e";
export var curvedTopBorder = "component-module--curvedTopBorder--fdef0";
export var footer = "component-module--footer--f248f";
export var fullWidth = "component-module--fullWidth--c2bb5";
export var header = "component-module--header--cec75";
export var headerTitle = "component-module--headerTitle--783f0";
export var medium = "component-module--medium--b8dcc";
export var narrow = "component-module--narrow--b79e4";
export var root = "component-module--root--8e66a";
export var sectionBar = "component-module--sectionBar--512ec";
export var wide = "component-module--wide--bda64";